import AuthWithPass from "components/AuthWithPass"
import FullPageLayout from "../layout/FullPageLayout"

export const AuthWithPassPage = () => {
    return (
      <FullPageLayout child={<AuthWithPass />}/>
    )
}